module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#tab-0"
    }
  }, [_vm._v("\n      Requests (" + _vm._s(_vm.joinReq.length) + ")\n    ")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n      Users (" + _vm._s(_vm.users.length) + ")\n    ")])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "tab-0"
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "md9": "",
      "offset-sm3": ""
    }
  }, [(_vm.joinReq.length === 0) ? _c('div', {
    staticClass: "info--text text-xs-center"
  }, [_vm._v("No requests")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.joinReq), function(req, k) {
    return _c('v-card', {
      key: k,
      staticClass: "ma-1 mb-2"
    }, [_c('v-card-text', {
      staticClass: "pa-1"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-2",
      staticStyle: {
        "border-right": "1px solid lightgray"
      },
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(" " + _vm._s(req.cust_name))]), _vm._v(" "), (!req.is_other_user) ? _c('div', {
      staticClass: "subheading"
    }, [_vm._v(" " + _vm._s(req.block_nm + ' ' + req.unit_no))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(req.ownership))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pl-3 pa-2",
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(req.role_name))]), _vm._v(" "), _c('div', {
      staticClass: "subheading"
    }, [_vm._v(" " + _vm._s(req.contact_phone))]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(req.contact_email))])]), _vm._v(" "), (req.show_rej) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "color": "grey"
      }
    }, [_c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          req.rej_reason = '', req.show_rej = false
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "hide-details": "",
        "label": "Rejection reason"
      },
      model: {
        value: (req.rej_reason),
        callback: function($$v) {
          _vm.$set(req, "rej_reason", $$v)
        },
        expression: "req.rej_reason"
      }
    })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
      staticClass: "pa-1"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": "",
        "color": req.show_rej ? 'accent' : ''
      },
      on: {
        "click": function($event) {
          _vm.acceptRejReq('reject-req', req), req.show_rej = true
        }
      }
    }, [_vm._v("Reject")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": "",
        "color": !req.show_rej ? 'accent' : ''
      },
      on: {
        "click": function($event) {
          return _vm.acceptRejReq('accept-req', req)
        }
      }
    }, [_vm._v("Accept")])], 1)], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-1"
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by name, unit no, status, etc.' : 'Search',
      "single-line": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "pt-2"
  }, [_vm._v("filter_list")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-1",
    attrs: {
      "items": _vm.roleForFilter,
      "item-text": "role_name",
      "item-value": "role_id",
      "label": "Roles",
      "return-object": "",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    on: {
      "click:clear": function($event) {
        return _vm.clearFilter()
      },
      "input": function($event) {
        return _vm.applyFilter()
      }
    },
    model: {
      value: (_vm.filterList.role_pair),
      callback: function($$v) {
        _vm.$set(_vm.filterList, "role_pair", $$v)
      },
      expression: "filterList.role_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.userHeadSm,
      "items": _vm.users,
      "title": "User list",
      "landscape": "true"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.userHeadSm : _vm.userHead,
      "items": _vm.users,
      "disable-initial-sort": "",
      "rows-per-page-items": [10, 25, 50, {
        'text': '$vuetify.dataIterator.rowsPerPageAll',
        'value': -1
      }],
      "pagination": _vm.pagination,
      "search": _vm.search
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "px-2"
        }, [_c('v-avatar', {
          attrs: {
            "slot": "activator",
            "size": "36px"
          },
          slot: "activator"
        }, [_c('img', {
          attrs: {
            "src": _vm.config.STATIC_FILES_DIR + props.item.avatar_url
          }
        })])], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(props.item.cust_name) + "\n                    "), (props.item.is_admin) ? _c('span', {
          staticClass: "caption grey--text"
        }, [_c('br'), _vm._v("Administrator\n                    ")]) : _vm._e(), _vm._v(" "), (props.item.role_name !== 'Resident') ? _c('span', {
          staticClass: "caption grey--text"
        }, [_c('br'), _vm._v(_vm._s(props.item.role_name) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(props.item.contact_phone))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(props.item.contact_email))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(props.item.block_nm))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(props.item.unit_no))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(props.item.ownership) + " ")]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-1"
        }, [_vm._v(_vm._s(!props.item.is_active ? 'Disabled' : props.item.is_other_user ? props.item.rel_status_if_other_user : props.item.rel_status) + "\n                  ")]), _vm._v(" "), _c('v-menu', {
          staticClass: "mt-2",
          attrs: {
            "bottom": "",
            "left": ""
          }
        }, [_c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [(props.item.is_other_user ? props.item.rel_status_if_other_user === 'Linked' : props.item.rel_status === 'Linked') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.userUpdate('delink', props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delink from this " + _vm._s(props.item.is_other_user ? 'community' : 'unit') + " ")])], 1) : (props.item.is_other_user ? props.item.rel_status_if_other_user === 'Delinked' : props.item.rel_status === 'Delinked') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.userUpdate('link', props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Link to this " + _vm._s(props.item.is_other_user ? 'community' : 'unit') + " ")])], 1) : _vm._e(), _vm._v(" "), (props.item.is_active) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.userUpdate('disable', props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("visibility_off")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Disable access")])], 1) : _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.userUpdate('enable', props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("accessibility")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Enable access")])], 1), _vm._v(" "), (props.item.is_admin) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.userUpdate('noadmin', props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Remove admin access")])], 1) : _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.userUpdate('admin', props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("supervisor_account")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Make an admin")])], 1), _vm._v(" "), _c('v-list-tile', {
          attrs: {
            "disabled": !props.item.is_other_user
          },
          on: {
            "click": function($event) {
              return _vm.updateRoles(props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change user role")])], 1)], 1)], 1)], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dlgInfo),
      callback: function($$v) {
        _vm.dlgInfo = $$v
      },
      expression: "dlgInfo"
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("User details")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dlgInfo = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "flat": ""
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.showRolesList),
      callback: function($$v) {
        _vm.showRolesList = $$v
      },
      expression: "showRolesList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      Change user role\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "item-text": "role_name",
      "item-value": "role_id",
      "label": "Roles",
      "return-object": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lChangedRoles.role_pair),
      callback: function($$v) {
        _vm.$set(_vm.lChangedRoles, "role_pair", $$v)
      },
      expression: "lChangedRoles.role_pair"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRolesList = false
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveRoles()
      }
    }
  }, [_vm._v("save")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-096c2994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users.vue
// module id = 899
// module chunks = 17